module.exports = __webpack_public_path__ + "f255d47e3a7366bb6e57559827bdd8cc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/scarf-zig-red-s.png
// module id = 2001
// module chunks = 0